/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `image_size` - IMAGE_SIZE * `group_bbox_size` - GROUP_BBOX_SIZE
 * @export
 * @enum {string}
 */

export const PointSizeBaseEnum = {
    ImageSize: 'image_size',
    GroupBboxSize: 'group_bbox_size'
} as const;

export type PointSizeBaseEnum = typeof PointSizeBaseEnum[keyof typeof PointSizeBaseEnum];



